import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService} from './auth.service';

import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

type contactType = {id: string, name: string, surname: string, nick: string, degreeBegin: string, degreeEnd: string, birthday: Date, note: string, telephone: string, email: string, adress: string, state: number, profileImage: string, idGroup: string};
type postType = Array<{id: string, textPost: string, place: string, postDate: DateTimeFormat, state: number, settings: number, postImage: string, people: concernType}>;
type mycontactsType = Array<{id: string, name: string, surname: string, nick: string, profileImage: string}>;
type concernType = Array<{idPost: string, idContact: string, name: string, surname: string, nick: string, profileImage: string}>;
type contactGroupType = Array<{id: string, title: string}>;

@Injectable()
export class ContactService {
  isLoaded: boolean = false;
  isActual: boolean = false;
  contact = {
    id: "", 
    name: "", 
    surname: "", 
    nick: "", 
    degreeBegin: "",
    degreeEnd: "",
    birthday: "",
    note: "", 
    telephone: "", 
    email: "",
    adress: "",
    idGroup: "",
    profileImage: "",
    state: 0
  };
  idContact: string;
  posts: postType = [];
  newPosts: postType = [];
  mycontacts: mycontactsType = [];
  contactGroups: contactGroupType = [];
  newConcern: concernType = [];
  fromPost: number = 0;
  postCount: number = 20;

  colors = ["white","yellow","green","light-blue","dark-blue","pink","red"];
  colorsName = ["Bílá","Žlutá","Zelená","Světle modrá","Tmavě modrá","Růžová","Červená"];

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };
  constructor(private http: HttpClient, private authService: AuthService) { 
    
  }

  getContacts(){
    this.authService.notify = "";

    let params = {
      "idUser": localStorage.getItem("idUser"),
      "idContact": this.idContact
    }
    this.http.post(this.authService.databaseURL+'getdata.php?table=mycontacts', params, this.httpOptions).subscribe(
      (data:any) => {
        this.mycontacts = data;
        this.isActual = true;
        this.isLoaded = true;
      },
      error => this.isActual = false
    )
    return this.mycontacts;
  }


  getContact(){
    this.authService.notify = "";

    let params = {
      "idUser": localStorage.getItem("idUser"),
      "idContact": this.idContact
    }
    this.http.post(this.authService.databaseURL+'getdata.php?table=contact', params, this.httpOptions).subscribe(
      (data:any) => {
        this.contact = data[0];
      },
      error => this.isActual = false
    )
    return this.contact;
  }

  getContactGroups(){
    this.authService.notify = "";

    let params = {
      "idUser": localStorage.getItem("idUser"),
    }
    this.http.post(this.authService.databaseURL+'getdata.php?table=contactgroups', params, this.httpOptions).subscribe(
      (data:any) => {
        this.contactGroups = data;
        this.addtoConcern(this.idContact);
      }
    )
    return this.contactGroups;
  }

  updateContact(editedContact){ 
    this.authService.notify = "";
    this.http.post(this.authService.databaseURL+'updatedata.php?table=contact', editedContact, this.httpOptions).subscribe(
      (data:any[]) => {
        this.contact = editedContact;
      },  
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }

  addPost(post){
    this.authService.notify = "";

    let params = {
      "id": "Q" + Date.now() + "-" + localStorage.getItem("idUser").slice(-10),
      "idUser": localStorage.getItem("idUser"),
      "textPost": post.textPost,
      "postDate": post.postDate.replace('T',' '),
      "postImage": post.postImage,
      "place": post.place,
      "settings": post.settings, 
      "state": 0,
      "people": this.newConcern
    } 

    this.http.post(this.authService.databaseURL+'adddata.php?table=post', params, this.httpOptions).subscribe(
      (data:any[]) => {
        this.posts.splice(0,0,params)
      },  
      error => {
        this.authService.notify = "Událost nebyla přidána. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
    
    if(this.newConcern.length > 0 && this.isActual == true){
      for(let i = 0; i < this.newConcern.length; i++){        
        this.newConcern[i].idPost = params.id;
        this.http.post(this.authService.databaseURL+'adddata.php?table=concern', this.newConcern[i], this.httpOptions).subscribe(
          (data:any[]) => {

          },  
          error => {
            i = 10000;
            this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
            this.isActual = false;
          }
        );
      }
      if(this.isActual == true){
        this.newConcern = [];
        this.addtoConcern(this.idContact);
      }
    }

    if(this.isActual == true) return true;
    else return false;
  }

  getPosts(){
    this.authService.notify = "";

    let params = {
      "idUser": localStorage.getItem("idUser"),
      "idContact": this.idContact,
      "fromPost": this.fromPost,
      "postCount": this.postCount
    }
    this.http.post(this.authService.databaseURL+'getdata.php?table=posts', params, this.httpOptions).subscribe(
      (data:any[]) => {
        if(this.fromPost > 0){
          this.newPosts = data;
          for(let i = 0; i < this.newPosts.length; i++){
            this.posts.push(this.newPosts[i]);
          }
        }
        else{
          this.posts = data;
        }
      },  
      error => {
        this.authService.notify = "Nepodařilo se načíst žádné události. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    )
    return this.posts;
  }

  addtoConcern(contactID){

    let isAdded = false;
    let concern = {
      "idPost": "",
      "idContact": "",
      "name": "",
      "surname": "",
      "nick": "",
      "profileImage": ""
    }

    for(let i = 0; i < this.newConcern.length; i++){
      if(contactID == this.newConcern[i].idContact) isAdded = true;
    }
    if(isAdded == false && contactID != ""){
      for(let i = 0; i < this.mycontacts.length; i++){
        if(contactID == this.mycontacts[i].id){
          concern.idContact = contactID;
          concern.name = this.mycontacts[i].name;
          concern.surname = this.mycontacts[i].surname;
          concern.nick = this.mycontacts[i].nick;
          concern.profileImage = this.mycontacts[i].profileImage;
          this.newConcern.push(concern);
          break;
        }
      }
    }  
  }

  removePost(i, id){
    this.authService.notify = "";   
    let project = {
      "id": id,
      "idUser": localStorage.getItem("idUser"),
    }
    this.http.post(this.authService.databaseURL+'removedata.php?table=post', project, this.httpOptions).subscribe(
      (data:any[]) => {

        this.posts.splice(i,1);
      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }

  removeContact(id){
    this.authService.notify = "";   
    let project = {
      "id": id,
      "idUser": localStorage.getItem("idUser"),
    }
    this.http.post(this.authService.databaseURL+'removedata.php?table=contact', project, this.httpOptions).subscribe(
      (data:any[]) => {
        this.authService.redirectToGroups();
      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }

  deleteConcern(contactID){  
    for(let i = 0; i < this.newConcern.length; i++){
      if(contactID == this.newConcern[i].idContact){
        this.newConcern.splice(i,1);
        break;
      }
    }
  }

  updatePost(editedPost,editedConcerns, selectedPost){
    this.authService.notify = "";

    editedPost.postDate = editedPost.postDate.replace('T',' ');    
    this.http.post(this.authService.databaseURL+'updatedata.php?table=post', editedPost, this.httpOptions).subscribe(
      (data:any[]) => {
        this.posts[selectedPost].textPost = editedPost.textPost;
        this.posts[selectedPost].postDate = editedPost.postDate;
        this.posts[selectedPost].settings = editedPost.settings;
        this.posts[selectedPost].place = editedPost.place;
        this.posts[selectedPost].people = editedConcerns;
        this.posts[selectedPost].postImage = editedPost.postImage;
      },  
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  
    editedPost.postDate = editedPost.postDate.replace(' ','T'); 

    if(editedConcerns.length > 0 && this.isActual == true){
      for(let i = 0; i < editedConcerns.length; i++){
        if(editedConcerns[i].state == -1){
          this.http.post(this.authService.databaseURL+'deletedata.php?table=concern', editedConcerns[i], this.httpOptions).subscribe(
            (data:any[]) => {

            },  
            error => {
              i = 10000;
              this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
              this.isActual = false;
            }
          );

        }
        else if(editedConcerns[i].state == 1){
          this.http.post(this.authService.databaseURL+'adddata.php?table=concern', editedConcerns[i], this.httpOptions).subscribe(
            (data:any[]) => {
      
            },  
            error => {
              i = 10000;
              this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
              this.isActual = false;
            }
          );
        }
        
      }
      let isDeleted = false;
      for(let i = editedConcerns.length - 1; i >= 0; i--){
        if(editedConcerns[i].state == -1){
          editedConcerns.splice(i,1);
          isDeleted = true;
        }
      }
      if(isDeleted == true){
        this.posts[selectedPost].people = [];
        this.posts[selectedPost].people = editedConcerns;
      }
    }

  }
 
  

}



// WEBPACK FOOTER //
// ./src/app/services/contact.service.ts